class PricingController {
    constructor() {
        this.products = [
            {
                badge: require('./images/badge1.png'),
                version: '免费版',
                price: 0,
                features: ['免费区块链登记</br>（100条/月）']
            },
            {
                badge: require('./images/badge2.png'),
                version: '高级版',
                price: 100,
                features: ['免费区块链登记', '免费侵权监测', '接口授权', '定制开发（费用另计）']
            },
            {
                badge: require('./images/badge3.png'),
                version: '豪华版',
                price: 1000,
                features: ['免费存证', '免费侵权监测']
            }
        ]
        this.selected = this.products[0]
    }

    onSelect(product) {
        if (product === this.selected) return
        this.selected = product
    }
}

export default PricingController;



// WEBPACK FOOTER //
// ./src/app/components/face/pricing/pricing.controller.js